export const CAPTCHA_POLL_RATE = 100;
export const CAPTCHA_RETRY_RATE = 110000;
export const CAPTCHA_MAX_WAIT_TIME = 5000;
